import { isPlatformBrowser } from '@angular/common';
import { Directive, Input, HostBinding, HostListener, AfterViewInit, OnDestroy, ElementRef, EventEmitter, Host, Output, Inject, PLATFORM_ID } from '@angular/core';

/**
 * //https://stackoverflow.com/a/64129877/6321055
 * 
 * https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
 * 
 * Usage:
<div (visibilityChange)="_visibilityChangeHandler($event)"
	enterTheViewportNotifier
	></div>
*/

@Directive({selector: "[enterTheViewportNotifier]"})
export class EnterTheViewportNotifierDirective implements AfterViewInit, OnDestroy {
	@Output() visibilityChange: EventEmitter<string> = new EventEmitter<string>();
	private _observer: IntersectionObserver;

	constructor(@Host() private _elementRef: ElementRef, @Inject(PLATFORM_ID) private platformId : Object) {}

	ngAfterViewInit(): void {
		const options = {
			root: null,
			rootMargin: "0px",
			threshold: 0.5 // % of element visibility to be 'visible'
		};
		if(isPlatformBrowser(this.platformId)){
			this._observer = new IntersectionObserver(this._callback, options);
			this._observer.observe(this._elementRef.nativeElement);
		}
	}

	ngOnDestroy() {this._observer?.disconnect();}

	private _callback = (entries, observer) => {
		entries.forEach(entry => {
			//console.log('enterTheViewportNotifier.entry:', entry);
			this.visibilityChange.emit(entry);
		});
	};
}